export const cibInstapaper = ["32 32","<path d='M19.688 27.010c0 2.427 0.359 2.786 3.911 3.057v1.932h-15.198v-1.932c3.557-0.271 3.911-0.63 3.911-3.057v-22.068c0-2.375-0.359-2.786-3.911-3.057v-1.885h15.198v1.885c-3.552 0.271-3.911 0.677-3.911 3.057z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-instapaper.js
// module id = null
// module chunks = 